import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { PrimeNG } from 'primeng/config';
import { DateInput } from '../../../models/inputs/date-input';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-date-input',
    standalone: true,
    imports: [CalendarModule, FormsModule, ReactiveFormsModule],
    template: `
        <p-calendar
            inputId="{{ 'input-' + name }}"
            [class]="control.inputClass.join(' ')"
            [maxDate]="control.max!"
            [minDate]="control.min!"
            [formControl]="control"
        ></p-calendar>
    `
})
export class DateInputComponent<T = Date> extends BaseInputComponent<T> {
    @Input() name!: string;
    @Input() override control!: DateInput<T>;

    constructor(private _config: PrimeNG) {
        super();
        this._config.setTranslation({
            firstDayOfWeek: 1,
            dateFormat: 'dd/mm/yy',
            dayNames: ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'],
            dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
            dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
            monthNames: [
                'gennaio',
                'febbraio',
                'marzo',
                'aprile',
                'maggio',
                'giugno',
                'luglio',
                'agosto',
                'settembre',
                'ottobre',
                'novembre',
                'dicembre'
            ],
            monthNamesShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
            today: 'Oggi',
            clear: 'Reset'
        });
    }
}
